import { render, staticRenderFns } from "./TasksGroupProposedTasks.vue?vue&type=template&id=c16182b6&scoped=true&"
import script from "./TasksGroupProposedTasks.vue?vue&type=script&lang=js&"
export * from "./TasksGroupProposedTasks.vue?vue&type=script&lang=js&"
import style0 from "./TasksGroupProposedTasks.vue?vue&type=style&index=0&id=c16182b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16182b6",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QScrollArea,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QScrollArea,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
